<template>
    <div class="cart-list">
        <Scroll class="wrapper" ref="scroll"
                :probe-type="0"
                :pull-up-load="true">
            <cart-list-item v-for="item in test" :item="item"></cart-list-item>

        </scroll>

    </div>
</template>

<script>
    import CartListItem from "./CartListItem";
    import Scroll from "../../../components/common/scroll/Scroll";
    export default {
        name: "CartList",
        components:{
            CartListItem,
            Scroll,
        },
        props:{
            test:'',
        },
        activated(){
            this.$refs.scroll.scroll.refresh();
        },

    }
</script>

<style scoped>
    .cart-list{
        position: relative;
        height: calc(100% - 140px);

        /*height: 450px;*/
/*background-color: red;*/
    }
    .wrapper{
        position: relative;
        /*height: calc(100% - 5px);*/
        height: calc(100%);
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
    }
</style>